'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getPayrollPeriod(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payroll_period_list`
        const result = await axios.get(url, {
          ...costumHeader('Get Payroll Period', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getPayrollPeriodDetail(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/payroll_period_detail`
        const result = await axios.get(url, {
          ...costumHeader('Get Payroll Period Detail', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  getPeriod(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/periods`
        const result = await axios.get(url, {
          ...costumHeader('Get Period', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve([])
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve([])
      }
    })
  },
  savePeriod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/periods`
        const result = await axios.post(url, body, costumHeader('Save Period', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editPeriod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/periods/${body.id}`
        const result = await axios.put(url, body, costumHeader('Edit Period', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deletePeriod(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/v1/periods/${body.id}`
        const result = await axios.delete(url, body, costumHeader('Delete Period', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }